import { AddressType } from '../../constants/address-type.js';
/** Subset of AddressType allowed on non-main-office addresses (excludes MAIN_OFFICE). */
export const NonMainOfficeAddressType = {
    SHIPPING: AddressType.SHIPPING,
    BILLING: AddressType.BILLING,
    REMIT_TO: AddressType.REMIT_TO,
};
/** True only for Shipping — the one type customers and vendors can mark default. */
export function isDefaultShippingEligibleTypeId(typeId) {
    return typeId === AddressType.SHIPPING;
}
//# sourceMappingURL=rules.js.map